import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Navigate, Outlet, useLocation } from 'react-router'
import { cargarYo } from '@/api/auth'
import { actualizarDatos } from '@/sesion/almacen'
import { useSesion } from '@/sesion/useSesion'

/**
 * Guarda de sesion. Sin token, al login (y se recuerda a donde iba).
 *
 * Con token restaurado desde sessionStorage se entra igual y auth/yo refresca
 * usuario y permisos por detras: si el token ya no sirve, el interceptor del
 * cliente limpia la sesion y esta misma guarda manda al login. Un fallo de red
 * no expulsa a nadie; se sigue con lo ultimo que se sabia.
 */
export default function RequiereSesion() {
  const { sesion } = useSesion()
  const ubicacion = useLocation()

  const yo = useQuery({
    queryKey: ['auth', 'yo'],
    queryFn: cargarYo,
    enabled: sesion !== null,
    retry: false,
    staleTime: 60_000,
  })

  const datos = yo.data

  useEffect(() => {
    if (datos !== undefined) {
      actualizarDatos({ usuario: datos.usuario, municipios: datos.municipios })
    }
  }, [datos])

  if (sesion === null) {
    return <Navigate to="/login" replace state={{ desde: ubicacion.pathname + ubicacion.search }} />
  }

  return <Outlet />
}
